import React from "react";
import { View, StyleSheet } from "react-native";
import PtText from "../pt-text/pt-text";
import PtIcon from "../pt-icon/pt-icon";
import {styleVars} from "../../../app-style-vars";

export default function PtCallout(props) {

  let calloutIcon = '';
  let calloutBackColor = 'rgba(191, 192, 194, 0.15)';
  let calloutTextColor = styleVars.boschLightGray;
  const defaultType = 'notype';

  const getCalloutStyleProps = () => {
    const type = props.type || defaultType;
    switch (type) {
      case 'error':
        calloutIcon = 'alert-error-filled';
        calloutBackColor = 'rgba(234, 0, 22, 0.15)';
        calloutTextColor = styleVars.boschRed;
        break;
      case 'warning':
        calloutIcon = 'alert-warning-filled';
        calloutBackColor = 'rgba(252, 175, 23, 0.15)';
        calloutTextColor = styleVars.boschYellow;
        break;
      case 'success':
        calloutIcon = 'alert-success-filled';
        calloutBackColor = 'rgba(120, 190, 32, 0.15)';
        calloutTextColor = styleVars.boschLightGreen;
        break;
      case 'info':
        calloutIcon = 'problem-frame';
        calloutBackColor = '#d1e4ff';
        calloutTextColor = '#000';
        break;
      default:
        break;
    }
  };

  getCalloutStyleProps();

  const styles = StyleSheet.create({
    calloutContainer: {
      minHeight: styleVars.rem(3),
      paddingLeft: styleVars.rem(3),
      backgroundColor: calloutBackColor,
      marginVertical: styleVars.rem(.25)
    },
    iconContainer: {
      width: styleVars.rem(3),
      height: '100%',
      position: 'absolute',
      left: 0,
      top: 0,
    },
    iconWrapper: {
      flex:1,
      flexGrow: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    messageContainer: {
      margin: 0,
      paddingHorizontal: 8,
      paddingVertical: 12,
    }
  });

  /** render content passed between opening and closing tag */
  const renderChildren = () => {
    let newChildren;
    if(Array.isArray(props.children)) {
      newChildren = props.children.map((child) => (
        typeof child !== "string" ? child : <PtText style={{color: calloutTextColor, lineHeight:styleVars.rem(1.5)}}>{child}</PtText>
      ));
    } else { /** props.children is not iterable if there's only one child */
      newChildren = typeof props.children !== "string" ? props.children : <PtText style={{color: calloutTextColor}}>{props.children}</PtText>
    }
    return newChildren
  };


  return (
    <View style={styles.calloutContainer}>
      <View style={styles.iconContainer}>
        <View style={styles.iconWrapper}>
          <PtIcon iconName={calloutIcon} iconColor={calloutTextColor} iconSize={styleVars.rem(2)} />
        </View>
      </View>
      <View style={styles.messageContainer}>
        {props.message ?
          <PtText style={{color: calloutTextColor, lineHeight:styleVars.rem(1.5)}}>{props.message}</PtText>
          : null
        }
        {props.children ?
          <View>{renderChildren()}</View>
          : null
        }
      </View>
    </View>
  )

}
